<!-- eslint-disable -->
<script setup>

import { ref, onMounted, computed, onBeforeMount} from 'vue';
import { useRouter } from 'vue-router';
import { closeModal, confirmModal } from '@kolirt/vue-modal'
import { useLanguagesStore } from '../../stores/languages';
import { useCurrenciesStore } from '../../stores/currencies';
import { useCountriesStore } from '../../stores/countries';
import { useRegisterStore } from '../../stores/register';
import { useCustomerStore } from '../../stores/customer';
import { useGeneralStore } from '@/stores/general';
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useReferralStore } from '@/stores/referral';
import { useBonusStore } from "@/stores/bonus";
import { usePaymentGatewaysStore } from "@/stores/payment_gateways";
import { useInitializeStore } from '@/stores/initialize';
import PromotionRewardsCard from '@/components/Common/PromotionRewardsCard.vue';

const svg_data = commonSvgs;
const { t } = useI18n();
const router = useRouter();
const customerStore = useCustomerStore();
const languagesStore = useLanguagesStore();
const countriesStore = useCountriesStore();
const currenciesStore = useCurrenciesStore();
const registerStore = useRegisterStore();
const initializeStore = useInitializeStore();
const generalStore = useGeneralStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const referralStore = useReferralStore();
const paymentGatewayStore = usePaymentGatewaysStore();
const bonusStore = useBonusStore();

const current_step = ref(1);
const password_visibility = ref(false);
const step_count = ref(1);
const registration_completed = ref(false);
const loading = ref(false);
const is_chat_enabled = ref(null);
const is_verification_enabled = ref(true)
const use_gradient = ref(true);
const is_country_ghana = process.env.VUE_APP_COUNTRY == 'GHANA';
const was_number_verified = ref(false);
const registered_rewards = ref(null);

const formatCurrency = (amount) => {
	if (customerStore.customer && customerStore.customer.currency) {
		return currenciesStore.format_currency(amount, customerStore.customer.currency.code);
	}
	return currenciesStore.format_currency(amount, currenciesStore.customer.currency.code);
};

const taboolaEventName = computed(() =>
	is_country_ghana ? "Betboroghana_registration" : "Betegram_registration"
);

onMounted(() => {
	initializeStore.fireTaboolaEventOnce(taboolaEventName.value);
});

const incrementCurrenctStep = () => {
	let validated = registerStore.validateStep(current_step.value)
	if (current_step.value == registerStore.getAllSteps ) {
		submitRegister()
	} else if (validated) {
		const enabled_fields = getStepFields();
		const hasUsernameOrEmail = enabled_fields.some(
			field => field.slug === 'email' || field.slug === 'username'
		);

		// if (hasUsernameOrEmail) {
		// 	let payload = {};

		// 	for (const field of enabled_fields) {
		// 		if (field.slug === 'email' || field.slug === 'username') {
		// 			payload[field.slug] = registerStore.register_input_fields[field.slug];
		// 		}
		// 	}

		// 	registerStore.checkRegister(payload).then(() => {
		// 			current_step.value++;
		// 		}).catch(error => {
		// 			console.log(error)
		// 		});

		// 	return;
		// }


		current_step.value++;
	}
}

const decrementCurrentStep = () => {
	current_step.value--;
}

const changeStep = (step) => {
	let validated;
	// Check if the step is greater than the current step, if validation passes, increment the current step
	if (current_step.value < step) {
		validated = registerStore.validateStep(current_step.value);
		// If validation passes, increment the current step
		if (validated) current_step.value++;
		// If the step is not greater and the current step decrement the current step
	} else if (current_step.value > 1) {
		current_step.value--;
	}
}

function getCookieValue(name) {
	let cookie_array = document.cookie.split(';');
	for (let i = 0; i < cookie_array.length; i++) {
		let cookie_pair = cookie_array[i].split('=');
		if (name == cookie_pair[0].trim()) {
			return decodeURIComponent(cookie_pair[1]);
		}
	}

	return null;
}

const submitRegister = () => {
	const enabled_fields = registerStore.getEnabledRegistrationFields;
	let payload = {};

	if (registerStore.register_input_fields.number_verification) {
		was_number_verified.value = true;
	}

	if (is_country_ghana) {
		if (!registerStore.register_input_fields.username) {
			let mobile_number = registerStore.register_input_fields.mobile_number;

			// If first digit is 0, remove it
			if (mobile_number.startsWith('0')) {
				mobile_number = mobile_number.substring(1);
			}

			payload['username'] = mobile_number;
		}
	}

	for (const field of enabled_fields) {
		if (registerStore.register_input_fields[field.slug]) {
			payload[field.slug] = registerStore.register_input_fields[field.slug];
		}
	}

	if (registerStore.register_input_fields.mobile_country_id) {
		payload['mobile_country_id'] = registerStore.register_input_fields.mobile_country_id;
	}

	const dob = _.find(enabled_fields, { slug: 'dob' });

	if (dob){
		payload['dob_day'] = registerStore.register_input_fields.dob_day;
		payload['dob_month'] = registerStore.register_input_fields.dob_month;
		payload['dob_year'] = registerStore.register_input_fields.dob_year;
	}

	payload['password_confirmation'] = registerStore.register_input_fields.password_confirmation;
	payload['utc_offset'] = registerStore.register_input_fields.utc_offset;
	payload['browser_timezone'] = registerStore.register_input_fields.browser_timezone;


	// Set affiliate cookies
	if (getCookieValue('af_btag') !== null) payload['btag'] = getCookieValue('af_btag');
	if (getCookieValue('af_link') !== null) payload['link'] = getCookieValue('af_link');
	if (getCookieValue('af_banner') !== null) payload['banner'] = getCookieValue('af_banner');

	// Use refer a friend code from component or cookie
	const inputReferralCode = registerStore.register_input_fields.refer_friend_code;
	const cookieReferralCode = getCookieValue('referral_code');

	if (inputReferralCode && inputReferralCode.trim() !== '') {
		// If input has value, use input and set method to 'code'
		payload['refer_a_friend_code'] = inputReferralCode.trim();
		payload['referral_method'] = 'code';
	} else if (cookieReferralCode !== null && cookieReferralCode !== '') {
		// If no input but cookie exists, use cookie and set method to 'link'
		payload['refer_a_friend_code'] = cookieReferralCode;
		payload['referral_method'] = 'link';
	}

	loading.value = true;

	registerStore.submitRegister(payload).then((response) => {
		if (customerStore.auth_token) {
			global.axios.defaults.headers['Authorization'] = 'Bearer ' + customerStore.auth_token;
			customerStore.fetchCustomer();
			customerStore.fetchProtectionConfiguration();

			paymentGatewayStore.fetchCustomerPaymentGateways();
			bonusStore.fetchOffers();
		}

		registered_rewards.value = response.promotion_code_rewards;

		// Clear referral cookie after successful registration
		referralStore.clearReferralCookie();

		loading.value = false;
		current_step.value++;

		registration_completed.value = true;

		// Fire ATHENA pixel sign_up event
		if (window.aPixel) window.aPixel.tag("sign_up");

		registerStore.initializeForm();
	}).catch(error => {
		if (error && error.data && error.data.errors) {
				current_step.value = registerStore.getFieldStep(Object.keys(error.data.errors)[0]);
				loading.value = false
				return error.data.message;
		}	else {
				loading.value = false;
			}
	});
}

const checkLanguageAndCloseModal = () => {
	if (useLanguagesStore().selected_language.id != customerStore.getCustomer.language.id) {
		window.location.reload();
	} else {
		closeModal();
	}
}

const number_verified = ref(false);
const isRegisterButtonDisabled = computed(() => {
	if (registerStore.hasNumberVerification == true && current_step.value == registerStore.getAllSteps) {
		if (number_verified.value == false) {
			return true;
		} else {
			return false;
		}
	}

	return false;
});

const callNow = () => {
	if (!is_chat_enabled) return;
	window.location.href = 	`tel:${process.env.VUE_APP_CALL_NOW_NUMBER}`;
};

const getStepFields = () => {
	return _.filter(registerStore.enabled_registration_fields, {step: String(current_step.value)})
}

const closeModalAndRedirect = () => {
	closeModal();
	router.push({ name: 'bank-deposits' });
}

onBeforeMount(() => {
	is_chat_enabled.value = platformConfigurationStore.isShowCallBubbleEnabled;
	use_gradient.value = platformConfigurationStore.isGradientColorOnLoginRegisterEnabled;
	if (!platformConfigurationStore.isCustomerVerificationEnabled) is_verification_enabled.value = false;
	if (!platformConfigurationStore.isEmailVerificationEnabled) is_verification_enabled.value = false;
})
</script>
<template>
	<section class="register-panel">
		<div class="container-full">
			<div class="register-panel-main">
				<span class="form-cross" >
					<a @click="closeModal" style="cursor: pointer;">
						<object v-html="svg_data.form_cross"></object>
					</a>
					</span>
					<div class="register-panel-left">
				<div class="register-image-box" :class="{ 'no-gradient': !use_gradient }">

					<div class="register-logo">
						<div class=""></div>
						<img :src="generalStore.getGeneral.header_logo" alt="register-logo" @click="closeModal">
					</div>

					<div class="register-bg-image">
						<img :src="generalStore.getGeneral.register_background" alt="register-bg"/>
					</div>

				</div>
			</div>

				<div class="register-panel-right">

					<div v-if="!registration_completed" id="multi-step-form-container" class="register-form-main">
						<h2>{{ $t('account.register.create_account') }}</h2>
						<!-- Form Steps / Progress Bar -->
						<ul class="form-register form-register-horizontal">
							<!-- Step 1 -->
							<li class=" form-register-list"  v-for="step_count in registerStore.getAllSteps" :key="step_count" :class="current_step  == step_count ? 'form-register-active' : 'form-register-unfinished'" @click="changeStep(step_count)" style="cursor: pointer;" :step="step_count">
								<a class="">
									<span class="form-register-circle text-muted">
										<span>{{step_count}}</span>
									</span>
								</a>
							</li>
						</ul>
						<!-- Step Wise Form Content -->
						<form class="register-outer-form" id="userAccountSetupForm" name="userAccountSetupForm"
							enctype="multipart/form-data" method="POST">
							<section v-for="step_count in registerStore.getAllSteps" :key="step_count" class="form-step">
									<template v-if="current_step == step_count">
										<div class="close_btn" style="cursor: pointer;">
											<a href="#" @click="closeModal" class="form-mobile-back-close">
												<object v-html="svg_data.form_cross"></object>
											</a>
										</div>

										<div class="register-inner-form">

										<template v-for="field in registerStore.getStepFieldComponents(step_count)" :key="field">
											<component :is="field"></component>
										</template>
										</div>

										<div v-if="step_count > 1" class="form-btns">
												<button @click="decrementCurrentStep" class="btn btn-navigate-form-step btn-form-prev" type="button"
													step_number="1">{{ $t('general.back') }}</button>
												<button v-if="!loading" @click="incrementCurrenctStep()" class="btn btn-secondary btn-navigate-form-step" type="button">
													{{ (current_step == registerStore.getAllSteps) ? $t('account.register.create_account') : $t('general.next') }}&nbsp;</button>
												<button v-else class="btn btn-secondary btn-navigate-form-step" type="button"><div class="loader-main"></div></button>
										</div>
										<div v-else class="form-btn-single">
												<button @click="incrementCurrenctStep()" class="btn btn-secondary btn-navigate-form-step" type="button">
													{{ (current_step == registerStore.getAllSteps) ? $t('account.register.create_account') : $t('general.next') }}&nbsp;
												</button>
										</div>
									</template>
								</section>
							</form>
						</div>

						<section v-if="registration_completed" id="step-4" class="form-step registration-success-step">
							<div class="success-icon-wrapper">
								<div class="success-icon-circle">
									<svg class="checkmark-svg" viewBox="0 0 52 52">
										<circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
										<path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
									</svg>
								</div>
							</div>

							<h2 class="success-title" v-if="registerStore.hasEmail && is_verification_enabled && !was_number_verified">
								{{ $t('account.register.thank_you_for_your_registration') }}
							</h2>
							<h2 class="success-title" v-else>
								{{ $t('account.register.thank_you_for_your_registration_no_email_field') }}
							</h2>

							<p class="success-subtitle" v-if="is_country_ghana && platformConfigurationStore.isGhanaSmsVerificationEnabled && !was_number_verified">
								{{ $t('account.register.verification_reminder') }}
							</p>
							<p class="success-subtitle" v-else-if="is_country_ghana && platformConfigurationStore.isGhanaSmsVerificationEnabled && was_number_verified">
								{{ $t('account.register.verification_success_text') }}
							</p>

							<!-- Promotion Code Rewards display -->
							<PromotionRewardsCard v-if="platformConfigurationStore.isPromotionCodeEnabled && registered_rewards && registered_rewards.length > 0" :rewards="registered_rewards" />

							<div class="success-buttons-group">
								<button @click="closeModalAndRedirect()" class="btn btn-deposit-now" type="button">
									{{ $t('bank.deposit.deposit') }}
								</button>
								<button @click="closeModal()" class="btn btn-close-modal" type="button">
									{{ $t('account.register.close') }}
								</button>
							</div>
						</section>

						<div v-if="!registration_completed" class="login-option">

							<div v-if="is_chat_enabled" class="help-container">
								<img src="@/assets/images/help-need.webp" @click="callNow()">
								<div class="text-container" @click="callNow()">
									<p>{{ $t('account.register.need_help') }}</p>
									<p>{{ $t('account.register.call_us') }}</p>
								</div>
							</div>

							<p style="margin-top: 14px;">{{ $t('account.register.already_registered') }} <a @click="confirmModal( {show_login: true} )" style="cursor: pointer;">{{ $t('account.login.login') }}</a></p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</template>

<style scoped>
.register-panel .register-panel-main .register-panel-left .register-image-box.no-gradient:before {
	background: none;
}

@media screen and (min-width: 1041px) and (max-width: 3000px){
	.register-panel-right .login-option {
		text-align: center;
	}
}
.form-btns {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}
html[dir="rtl"] .register-panel .register-panel-main .form-cross {
	right: unset;
	left: 30px;
}
html[dir="rtl"] .register-form-main .form-mobile-back {
	left: unset;
	right: 20px;
	transform: rotate(180deg);
}

.disabled-button {
	background: transparent;
	pointer-events: none;
	border: 1px solid var(--tab-gray);
	color: var(--tab-gray);
}

.register-form-main .form-mobile-back-close {
	position: absolute;
	top: 22px;
	right: 20px;
	display: none;
	z-index: 10;
}

html[dir="rtl"] .register-form-main .form-mobile-back-close {
	right: unset;
	left: 20px;
}

@media screen and (max-width: 767px) {
	.register-form-main .form-mobile-back-close {
		display: block;
	}
}

.register-panel .register-panel-main .register-panel-left .register-image-box .register-logo {
	align-items: center;
}

.help-container {
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 2%;
	cursor: pointer;
}

.help-container .text-container p {
	font-size: 12px;
	line-height: 1;
	color: var(--white);
}

/* Success screen layout & animations */
.registration-success-step {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 20px 30px;
	height: 100%;
}

.success-icon-wrapper {
	margin-bottom: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.success-icon-circle {
	width: 80px;
	height: 80px;
	border-radius: 50%;
	background: color-mix(in srgb, var(--primary) 10%, transparent);
	border: 2px solid color-mix(in srgb, var(--primary) 20%, transparent);
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 25px color-mix(in srgb, var(--primary) 25%, transparent);
	animation: pulseGlow 2s infinite ease-in-out;
}

.checkmark-svg {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	display: block;
	stroke-width: 3.5;
	stroke: var(--primary);
	stroke-miterlimit: 10;
}

.checkmark-circle {
	stroke-dasharray: 166;
	stroke-dashoffset: 166;
	stroke-width: 2.5;
	stroke-miterlimit: 10;
	stroke: var(--primary);
	fill: none;
	animation: strokeCircle 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
	transform-origin: 50% 50%;
	stroke-dasharray: 48;
	stroke-dashoffset: 48;
	animation: strokeCheck 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

@keyframes strokeCircle {
	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes strokeCheck {
	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes pulseGlow {
	0%, 100% {
		transform: scale(1);
		box-shadow: 0 0 20px color-mix(in srgb, var(--primary) 20%, transparent);
		border-color: color-mix(in srgb, var(--primary) 20%, transparent);
	}
	50% {
		transform: scale(1.05);
		box-shadow: 0 0 30px color-mix(in srgb, var(--primary) 40%, transparent);
		border-color: color-mix(in srgb, var(--primary) 40%, transparent);
	}
}

.success-title {
	font-size: 1.4rem !important;
	color: var(--white) !important;
	font-weight: 700;
	line-height: 1.3;
	margin: 0 0 12px 0 !important;
	padding-bottom: 0 !important;
	text-align: center;
	letter-spacing: -0.02em;
}

.success-subtitle {
	color: var(--light-gray);
	font-size: 0.95rem;
	line-height: 1.5;
	max-width: 420px;
	margin: 0 auto 24px auto !important;
	font-weight: 300;
}

/* Glassmorphic Rewards Card */
.success-rewards-card {
	background: linear-gradient(135deg, color-mix(in srgb, var(--white) 3%, transparent) 0%, color-mix(in srgb, var(--white) 1%, transparent) 100%);
	border: 1px solid color-mix(in srgb, var(--white) 8%, transparent);
	border-radius: 12px;
	padding: 16px 20px;
	width: 100%;
	max-width: 400px;
	margin: 0 auto 24px auto;
	box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
}

.rewards-card-header {
	display: flex;
	align-items: center;
	gap: 12px;
	text-align: left;
	border-bottom: 1px solid color-mix(in srgb, var(--white) 6%, transparent);
	padding-bottom: 12px;
	margin-bottom: 12px;
}

.gift-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	background: color-mix(in srgb, var(--primary) 15%, transparent);
	border-radius: 8px;
	flex-shrink: 0;
}

.gift-icon :deep(svg) {
	width: 24px;
	height: 24px;
	stroke: var(--primary);
	fill: none;
}

.rewards-card-title-group {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.rewards-card-badge {
	font-size: 0.7rem;
	text-transform: uppercase;
	font-weight: 700;
	letter-spacing: 0.05em;
	color: var(--primary);
}

.rewards-title {
	font-size: 0.95rem;
	font-weight: 600;
	color: var(--white);
	margin: 0;
}

.rewards-list-container {
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: flex-start;
	padding-left: 6px;
}

.reward-item {
	display: flex;
	align-items: center;
	gap: 8px;
	color: var(--white);
}

.reward-bullet {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: var(--primary);
	box-shadow: 0 0 8px var(--primary);
}

.reward-name {
	font-size: 0.9rem;
	font-weight: 500;
}

.reward-qty {
	font-size: 0.85rem;
	opacity: 0.8;
	font-weight: 400;
	margin-left: 4px;
}

/* Button Group Alignment */
.success-buttons-group {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	width: 100%;
	max-width: 400px;
	margin: 0 auto;
}

.btn-deposit-now {
	background-color: var(--secondary) !important;
	color: var(--buttons-text-color) !important;
	border: none !important;
	font-weight: bold !important;
	cursor: pointer;
	padding: 10px 28px !important;
	border-radius: 6px !important;
	font-size: 0.9rem !important;
	transition: all 0.2s ease-in-out !important;
	box-shadow: 0 4px 12px rgba(255, 187, 2, 0.2) !important;
	flex: 1;
}

.btn-deposit-now:hover {
	transform: translateY(-1px);
	box-shadow: 0 6px 16px rgba(255, 187, 2, 0.3) !important;
}

.btn-close-modal {
	background-color: color-mix(in srgb, var(--white) 5%, transparent) !important;
	color: var(--white) !important;
	border: 1px solid color-mix(in srgb, var(--white) 10%, transparent) !important;
	font-weight: 600 !important;
	cursor: pointer;
	padding: 10px 28px !important;
	border-radius: 6px !important;
	font-size: 0.9rem !important;
	transition: all 0.2s ease-in-out !important;
	flex: 1;
}

.btn-close-modal:hover {
	background-color: color-mix(in srgb, var(--white) 10%, transparent) !important;
	border-color: color-mix(in srgb, var(--white) 20%, transparent) !important;
}
</style>